import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root';
import { Customer } from './model';

export const SIMULATOR_FEATURE_KEY = 'simulator';

interface SimulatorState {
  chatId?: string;
  customer?: Customer;
  gotCustomerDetails?: boolean;
  localhostPort?: string;
  simulatorInviteId: string;
}

const initialSimulatorState: SimulatorState = {
  simulatorInviteId: '',
};

export const simulatorSlice = createSlice({
  name: SIMULATOR_FEATURE_KEY,
  initialState: initialSimulatorState,
  reducers: {
    updateChatId(state, action: PayloadAction<string>) {
      state.chatId = action.payload;
    },
    updateCustomer(state, action: PayloadAction<Customer>) {
      state.customer = action.payload;
    },
    updateGotCustomerDetails(state, action: PayloadAction<boolean>) {
      state.gotCustomerDetails = action.payload;
    },
    updateLocalhostPort(state, action: PayloadAction<string>) {
      state.localhostPort = action.payload;
    },
    updateSimulatorInviteId(state, action: PayloadAction<string>) {
      state.simulatorInviteId = action.payload;
    },
  },
});

export const {
  updateChatId,
  updateCustomer,
  updateGotCustomerDetails,
  updateLocalhostPort,
  updateSimulatorInviteId,
} = simulatorSlice.actions;

export const simulatorSliceState = (rootState: RootState): SimulatorState =>
  rootState[SIMULATOR_FEATURE_KEY];

export const getChatId = createSelector(
  simulatorSliceState,
  (state) => state.chatId
);

export const getCompanyName = createSelector(
  simulatorSliceState,
  (state) => state.customer?.companyName
);

export const getCustomer = createSelector(
  simulatorSliceState,
  (state) => state.customer
);

export const getCustomerRefreshToken = createSelector(
  simulatorSliceState,
  (state) => state.customer?.refreshToken
);

export const getCustomerToken = createSelector(
  simulatorSliceState,
  (state) => state.customer?.token
);

export const getGotCustomerDetails = createSelector(
  simulatorSliceState,
  (state) => state.gotCustomerDetails
);

export const getLocalhostPort = createSelector(
  simulatorSliceState,
  (state) => state.localhostPort
);

export const getSenderUserId = createSelector(
  simulatorSliceState,
  (state) => state.customer?.senderUserId
);

export const getSimulatorInviteId = createSelector(
  simulatorSliceState,
  (state) => state.simulatorInviteId
);
